import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BlogLinksComponent } from './blog-links.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [BlogLinksComponent],
  imports: [
    CommonModule,
    RouterModule
  ],
  exports: [BlogLinksComponent]
})
export class BlogLinksModule { }
